import React, { useEffect, useState } from "react";
import PageTableLayout from "../../components/Pagetablelayout";
import axios from "axios";
import { Space, Button, Modal, Form, Input, Select } from "antd";

export default function TagsPage() {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingTag, setEditingTag] = useState(null);
  const [form] = Form.useForm();

  const token = localStorage.getItem("jwt");

  const fetchTags = async () => {
    setLoading(true);
    try {
      const res = await axios.get("https://mdgholidaydreams.com/api/tags", {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      setTags(res.data);
    } catch (err) {
      console.error("Fetch tags failed:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTags();
  }, []);

  const handleAdd = () => {
    setEditingTag(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingTag(record);
    form.setFieldsValue({
      name: record.name,
      active: record.active,
    });
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingTag) {
        await axios.put(`https://mdgholidaydreams.com/api/tags?id=${editingTag.id}`, values, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
      } else {
        await axios.post("https://mdgholidaydreams.com/api/tags", values, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
      }
      form.resetFields();
      setIsModalVisible(false);
      setEditingTag(null);
      fetchTags();
    } catch (err) {
      console.error(err);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingTag(null);
    form.resetFields();
  };

  const columns = [
    { title: "Tag Name", dataIndex: "name", key: "name" },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      render: active => (active ? "Active" : "Inactive"),
    },
    { title: "Created By", dataIndex: "created_by", key: "created_by" },
    { title: "Updated By", dataIndex: "updated_by", key: "updated_by" },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button onClick={() => handleEdit(record)}>Edit</Button>
          <Button
            danger
            onClick={() =>
              axios.patch(`https://mdgholidaydreams.com/api/tags?id=${record.id}`, {}, {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
              }).then(fetchTags)
            }
          >
            Deactivate
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <>
      <PageTableLayout
        breadcrumb={["Admin", "Tags"]}
        title="Manage Tags"
        addButtonLabel="Add Tag"
        onAdd={handleAdd}
        columns={columns}
        dataSource={tags}
        loading={loading}
        onRefresh={fetchTags}
      />

      <Modal
        title={editingTag ? "Edit Tag" : "Add New Tag"}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Save"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Tag Name"
            rules={[{ required: true, message: "Please enter a tag name" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="active"
            label="Status"
            rules={[{ required: true, message: "Please select status" }]}
          >
            <Select placeholder="Select status">
              <Select.Option value={1}>Active</Select.Option>
              <Select.Option value={0}>Inactive</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
